import React from 'react'
import { shape, string, func, bool } from 'prop-types'
import moment from 'moment'
import { useSelector } from 'react-redux'

import { selectLanguage } from '../../../redux/session/selectors'
import { selectLabels } from '../../../redux/configuration/selectors'

import ResourceAvailability from '../ResourceAvailability/ResourceAvailability'

// ICONS
import moonIcon from '../../../assets/icons/moon.svg'

// STYLES
import './DefaultCrossingCard.scss'

const DefaultCrossingCard = ({
  accommodationsAvailable,
  crossing,
  departureDate,
  isCurrentlySelectedRoute,
  isDisabled,
  isOverNight,
  selectCrossing,
  vehiclesAvailable,
  petExteriorAvailable,
  passengerAvailability,
  activeVehicleResourceCode
}) => {
  const labels = useSelector(selectLabels)
  const language = useSelector(selectLanguage)

  let shipName = labels[crossing.shipCode]
  if (!shipName && crossing.shipCode === 'SA') {
    shipName = 'MV Sareemaa'
  }
  return (
    <div
      role={'button'}
      tabIndex={0}
      className={`btn crossing ${
        isCurrentlySelectedRoute ? 'current-active-route' : ''
      } ${isOverNight ? 'overnight-card' : ''} ${isDisabled ? 'disabled' : ''}`}
      key={`${crossing.departureDate}-${crossing.departureTime}`}
      onClick={() => {
        if (!isDisabled) {
          selectCrossing(crossing)
        }
      }}
      onKeyDown={e => {
        if (e.keyCode === 13 || e.keyCode === 32) {
          if (!isDisabled) {
            selectCrossing(crossing)
          }
        }
      }}
    >
      <div className="header">
        <p className="title label u-remove-margin">{labels.departureTime}</p>
        <p className="title time u-remove-margin">{crossing.departureTime}</p>

        {isOverNight && (
          <div className="overnight-indicator">
            <img src={moonIcon} alt="" />
            <p>{`${labels.nightOf} ${moment(departureDate)
              .locale(language)
              .subtract(1, 'days')
              .format('dddd')} ${labels.to} ${moment(departureDate)
              .locale(language)
              .format('dddd')}`}</p>
          </div>
        )}
      </div>

      <ResourceAvailability
        vehiclesAvailable={vehiclesAvailable}
        accommodationsAvailable={accommodationsAvailable}
        shipName={shipName}
        passengerAvailability={passengerAvailability}
        petExteriorAvailable={petExteriorAvailable}
        activeVehicleResourceCode={activeVehicleResourceCode}
      />
    </div>
  )
}

DefaultCrossingCard.propTypes = {
  accommodationsAvailable: bool,
  crossing: shape().isRequired,
  departureDate: string.isRequired,
  isCurrentlySelectedRoute: bool,
  isDisabled: bool,
  isOverNight: bool,
  selectCrossing: func.isRequired,
  vehiclesAvailable: bool,
  petExteriorAvailable: bool,
  passengerAvailability: bool,
  activeVehicleResourceCode: string
}

export default DefaultCrossingCard
